function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m285 61h-270c-8.28 0-15 6.72-15 15v330c0 8.28 6.72 15 15 15h30c0-33.08 26.92-60 60-60s60 26.92 60 60h135v-345c0-8.28-6.72-15-15-15zm-24.54 120.75c-13.83 13.83-34.49 16.76-51.21 8.78l-79.7 79.7c8 16.73 5.07 37.36-8.8 51.23-5.85 5.86-15.35 5.86-21.21 0s-5.86-15.36 0-21.21c5.86-5.87 5.86-15.35 0-21.22-5.85-5.84-15.36-5.85-21.21 0-5.86 5.86-15.36 5.86-21.22 0-5.85-5.85-5.85-15.35 0-21.21 13.87-13.87 34.5-16.8 51.23-8.8l79.68-79.68c-8-16.73-5.07-37.36 8.8-51.23 5.86-5.85 15.36-5.85 21.21 0 5.86 5.86 5.86 15.36 0 21.22s-5.86 15.35 0 21.21c5.85 5.85 15.37 5.85 21.22 0 5.85-5.86 15.35-5.86 21.21 0s5.86 15.36 0 21.21z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 421,
  r: 30
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 407,
  cy: 421,
  r: 30
})), /*#__PURE__*/React.createElement("path", {
  d: "m441.21 241h-111.21v-90h53.58c20.68 0 38.63 14.02 43.65 34.09z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m512 286v120c0 8.28-6.72 15-15 15h-30c0-33.08-26.92-60-60-60s-60 26.92-60 60h-17v-150h167c8.28 0 15 6.72 15 15z"
}));

var SvgJobs = function SvgJobs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jobs.3193bc81.svg";
export { ForwardRef as ReactComponent };